<template>
  <label class="switch">
    <input v-model="newValue" type="checkbox">
    <span class="slider round" :style="buttonColor"></span>
  </label>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: null
    },
    switchColor: {
      type: String,
      default: 'red'
    },
    inverted: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return { newValue: this.modelValue };
  },
  computed: {
    buttonColor () {
      if (this.inverted) {
        return `--switch-color-checked:var(--medium-grey2); --switch-color-unchecked:var(--${this.switchColor});`;
      }
      return `--switch-color-checked:var(--${this.switchColor});`;
    }
  },
  watch: {
    modelValue (val) {
      this.newValue = val;
    },
    newValue (val) {
      this.$emit('update:modelValue', val);
    }
  }
};
</script>
